import {BusinessGroupParamsController} from "@/controllers/business/BusinessGroupParamsController";
import {cleanVatRegimes} from "@/purchase/vatRegime";

let pending;

// Historique du régime de TVA du groupe (lu une fois, rechargé après un changement de paramètres)
export async function loadVatRegimes() {
    if (!pending) {
        pending = BusinessGroupParamsController.get(localStorage.groupId)
            .then(params => params && !params.errors ? cleanVatRegimes(params.vatRegimes) : [])
            .catch(() => []);
    }
    return pending;
}

export function resetVatRegimes() {
    pending = undefined;
}
